import {Body} from '../../../typography/body';

import {PhoneRowEditState} from '../../phone-row/phone-row-edit-state';

type Props = {
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
    numberFormattedWithCountryCode: string | null | undefined;
    extension: string | null | undefined;
    onChange: (number: string, extension: string) => Promise<any>;
    placeholder: string;
};

export function PhoneCustomField(props: Props) {
    const fullFormattedPhoneNumber = props.numberFormattedWithCountryCode
        ? `${props.numberFormattedWithCountryCode} ${
              props.extension ? ` ext. ${props.extension}` : ''
          }`
        : '';

    if (props.isEditing) {
        return (
            <PhoneRowEditState
                isEditing={props.isEditing}
                setIsEditing={props.setIsEditing}
                numberFormattedWithCountryCode={props.numberFormattedWithCountryCode}
                extension={props.extension}
                onChange={props.onChange}
            />
        );
    }

    return (
        <Body size='small' color={fullFormattedPhoneNumber ? 'medium' : 'light'}>
            {fullFormattedPhoneNumber || props.placeholder}
        </Body>
    );
}
